<template>
  <div
    class="modal fade"
    id="rejectApplicantModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            ref="close"
            @click="resetForm"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="myModalLabel"
          >
            {{ $t('string.rejectApplicant') }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="form-horizontal">
              <div
                class="form-group"
                :class="{'has-error' : validations['reason']}"
              >
                <label class="required">{{ $t('string.reason') }}</label>
                <template v-if="reasonOptions && Array.isArray(reasonOptions) && reasonOptions.length">
                  <div
                    class="checkbox"
                    :key="key"
                    v-for="(item, key) in reasonOptions"
                  >
                    <label>
                      <input
                        type="checkbox"
                        :value="item.id"
                        v-model="selected_cancellation_options"
                      >
                      {{ item.reason }}
                    </label>
                  </div>
                </template>
                <template v-else>
                  <p class="text-muted">
                    Please define the cancellation reason
                  </p>
                </template>
                <div
                  v-if="validations['reason']"
                  class="mt-2"
                >
                  <span class="label-error">{{ validations['reason'][0] }}</span>
                </div>
              </div>
              <div
                class="form-group"
                :class="{'has-error' : other_reason_validation}"
                v-if="visibleOtherText"
              >
                <label for="other_reason">{{ $t('string.otherReason') }}</label>
                <textarea
                  class="form-control"
                  v-model="other_reason"
                  id="other_reason"
                />
                <template v-if="other_reason_validation">
                  <span class="label-error">The other reason field is required</span>
                </template>
              </div>
            </div>
          </div>
          <div class="clearfix" />
        </div>
        <div class="modal-footer">
          <button
            :disabled="isLoading"
            @click="resetForm"
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button-async-loading
            @click="onSave"
            :title="$t('button.save')"
            :is-loading="isLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonAsyncLoading from '@/views/borrows/_components/ButtonAsyncLoading'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ApplicantRejectionModal',
  components: { ButtonAsyncLoading },
  data () {
    return {
      isLoading: false,
      reasonOptions: [],
      selected_cancellation_options: [],
      other_reason: null,
      validations: {},
      other_reason_validation: false,
      order_reason_id: null
    }
  },
  computed: {
    ...mapState({
      product: state => state.rejectApplicant.product,
      applicable_id: state => state.rejectApplicant.applicable_id
    }),
    ...mapGetters('rejectApplicant', {
      fetchData: 'fetchData'
    }),
    visibleOtherText () {
      let visible = false
      if (this.selected_cancellation_options.length) {
        this.selected_cancellation_options.forEach((selected_option_id) => {
          this.reasonOptions.forEach((option) => {
            if (option.id === selected_option_id && option.reason === 'Other') {
              this.order_reason_id = option.id
              visible = true
            }
          })
        })
      }
      return visible
    }
  },
  watch: {
    fetchData () {
      this.getReasonOption()
    }
  },
  methods: {
    resetForm () {
      this.validations = {}
      this.other_reason_validation = false
      this.other_reason = null
      this.order_reason_id = null
      this.selected_cancellation_options = []
      this.isLoading = false
    },
    async onSave (e) {
      this.validations = {}
      this.other_reason_validation = false
      if (
        this.visibleOtherText &&
        (this.other_reason === null || this.other_reason === '' || this.other_reason === undefined)
      ) {
        this.isLoading = false
        this.other_reason_validation = true
        return 0
      }

      this.isLoading = true
      await this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/rejected', {
        applicant_id: this.applicable_id,
        reason: this.selected_cancellation_options,
        other_reason: this.other_reason,
        other_reason_id: this.order_reason_id
      }).then((response) => {
        if (response.data && response.data.data) {
          this.resetForm()
          this.$refs.close.click()
          this.$emit('refreshList')
        }
      }).catch((error) => {
        if (error.response && error.response.status && error.response.status === 422) {
          this.validations = error.response.data.errors
        } else {
          this.onResponseError(error)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    getReasonOption () {
      this.$axios.post(this.$base_api + '/api/v4/backend/reason/get-option', {
        list_type: 'for_rejection',
        product_type: this.product
      }).then(({ data }) => {
        if (data.data) {
          this.reasonOptions = data.data
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isSaveWaiting = false
      })
    }
  }
}
</script>

<style scoped>

</style>
